<template>
  <div class="alarm-wrap" v-if="showLength">
    <template v-for="(item, i) in messages">
      <div class="el-notification right noshadow" :class="{'boxshadow': showLength<3}" v-if="item.show">
        <i class="el-icon el-notification__icon el-notification--warning">
          <el-icon><WarningFilled /></el-icon>
        </i>
        <div class="el-notification__group">
          <div class="el-notification__title">{{ item.title }}<span class="num">{{ showLength }}</span></div>
          <div class="el-notification__content">
            <div>
              <div v-if="item.levelName">{{item.levelName}}</div>
              <div v-if="item.alarmTypeName">{{item.alarmTypeName}}</div>
              <div v-if="item.deviceName">{{item.deviceName}}-{{item.rtuName}}-{{item.itemName}}</div>
              <div v-if="item.alarmVal">{{item.preSetValName}}：{{item.alarmVal}}</div>
              <div v-if="item.val" style="color:red;">{{item.currentValName}}：{{item.val}}</div>
              <div v-if="item.time">{{item.startTime}}：{{item.time}}</div>
            </div>
          </div>
          <!-- 关闭全部 -->
          <!-- <el-popover :visible="visible" placement="top" :width="260">
            <p>Are you sure to delete ?</p>
            <div style="display: flex;">
              <el-button size="small" @click="visible = false">{{ Lang.btn.cancel }}</el-button>
              <el-button size="small" type="primary" @click="toggleAll">
                {{Lang.btn.confirm}}
              </el-button>
            </div>
            <template #reference>
              <div class="el-icon el-notification__closeBtn">
                <el-icon @click="visible = true"><Close /></el-icon>
              </div>
            </template>
          </el-popover> -->

          <div class="el-icon el-notification__closeBtn">
            <el-icon @click="toggleAll"><Close /></el-icon>
          </div>
          <div v-if="showLength > 1" class="el-icon next" @click="toggleShow(i)">
            <el-icon><ArrowDown /></el-icon>
          </div>
          <div class="el-icon voice" @click="toggleVoice">
            <comp-icon v-if="!voice" name="voice-off" size="18"></comp-icon>
            <comp-icon v-else name="voice-open" size="14"></comp-icon>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { webSocketService } from '@/api/alarmevent/websocket';
import { alarmLevels } from '@/const/options';
import dayjs from 'dayjs';
import { getToken } from '@/utils/auth';
import { useStore } from 'vuex';
import { Lang, say } from '@/lang/lang';

const messages = ref([]);
const visible = ref(false)
const voice = ref(true)
const showLength = computed({
  get: () => messages.value.filter(item => item.show).length,
})

const store = useStore();
const language = computed(() => store.getters.language);

const toggleShow = (i) => {
  messages.value[i].show = false;
}

const checkPlayVoice = () => {
  if (!voice.value) {
    if ('speechSynthesis' in window) {
      if (window.speechSynthesis.pause) {
        console.log('暂停播放')
        window.speechSynthesis.pause();
      } else {
        console.log('停止播放')
        window.speechSynthesis.cancel();
      }
    } else {
      console.log('当前浏览器不支持 speechSynthesis');
    }
  } else {
    if ('speechSynthesis' in window && window.speechSynthesis.resume) {
      console.log('恢复播放')
      window.speechSynthesis.resume();
    }
  }
}

const toggleVoice = () => {
  voice.value = !voice.value;
  checkPlayVoice()
}

const toggleAll = () => {
  messages.value.forEach(item => item.show = false);
}

const sendMessage = () => {
  webSocketService.send({"alarmLevel":2,"alarmType":4,"alarmTypeName":"Beyond the lower limit","alarmVal":545.0000,"createTime":1732705831078,"deviceId":"88888888","deviceName":"网关","id":"1861729308554964993","isDeleted":0,"itemId":"88888888_1_1_3","itemName":"C相电压","projectId":1839546739343265793,"rtuId":"88888888_1_1","rtuName":"变压器温控","startTime":1732705830000,"status":1,"tenantId":"000000","updateTime":1732705831078,"val":222});
};

webSocketService.on('message', (data) => {
  console.log('webSocketService on message')
  const obj = JSON.parse(data);
  const levelName = alarmLevels[obj.alarmLevel].label;
  const preSetValName = Lang.tips.preSetVal;
  const currentValName = Lang.tips.currentVal;
  const title = Lang.tips.alarm;
  const startTime = Lang.label.alarmStartTime;

  const time = dayjs(obj.startTime).format('YYYY-MM-DD HH:mm:ss');
  const alarmTypeName = obj.alarmTypeName || '';
  const deviceName = obj.deviceName || '';
  const rtuName = obj.rtuName || '';
  const itemName = obj.itemName || '';
  const alarmVal = obj.alarmVal || '';
  const val = obj.val || '';

  const speakText = `
    ${title}
    ${levelName}
    ${deviceName} ${rtuName} ${itemName}
    ${preSetValName} ${alarmVal}
    ${currentValName} ${val}
    ${startTime} ${time}
  `
  say(speakText, language);
  messages.value.push({
    title,
    levelName,
    preSetValName,
    currentValName,
    alarmTypeName,
    deviceName,
    rtuName,
    itemName,
    startTime,
    alarmVal,
    val,
    time,
    show: true,
  });

});

onMounted(() => {
  const token = getToken();
  if (token) {
    if (webSocketService && webSocketService.connect) {
      webSocketService.connect();
      console.log('websocket 前端尝试建立链接')
    }
  }
});

onBeforeUnmount(() => {
  if (webSocketService && webSocketService.close) {
    webSocketService.close();
  }
  console.log('websocket 前端关闭链接')
});
</script>
<style lang="scss">

</style>